import React from "react"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import { Link, useLocation } from "react-router-dom"
import arrow from "../../assets/icons/arrow.svg"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import cardIon from "../../assets/icons/card-icon.png"
import FinanceDahboard from "../FinanceDashboard"
import DotIcon from "./voucherEntry/dotsvg"
import RenderSubmenu from "../../components/Common/renderMenu"
const Finance = () => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Finance${companyname ? ` | ${companyname}` : ""}`

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)

  const location = useLocation()

  const menuItem = loggedUser?.smenu?.find(
    item => item.linkTo === `${location?.pathname}`
  )

  console.log(`menuItem`, menuItem)

  const cardData = [
    { name: "Total Products", amount: "1000", icon: cardIon },
    { name: "Total  Brands", amount: "2000", icon: cardIon },
    { name: "Total  Type", amount: "3000", icon: cardIon },
    { name: "Total Group", amount: "4000", icon: cardIon },
  ]

  const accountBook = [
    {
      name: "Cash Book",
      linkTo: "/finance/cash-book",
    },
    {
      name: "Bank Book",
      linkTo: "/finance/bank-book",
    },
    {
      name: "Day Book",
      linkTo: "/finance-day-book",
    },
    {
      name: "Account Book",
      linkTo: "/finance-account-book",
    },
    {
      name: "Sales Register",
      linkTo: "/finance/sales-register",
    },
    {
      name: "Purchase Register",
      linkTo: "/finance/purchase-register",
    },
    {
      name: "Receipt Register",
      linkTo: "/finance/receipt-register",
    },
    {
      name: "Payment Register",
      linkTo: "/finance/payment-register",
    },
    {
      name: "Journal Register",
      linkTo: "/finance/journal-register",
    },
    {
      name: "Cost Category Report",
      linkTo: "/finance/cost-category-report",
    },
    {
      name: "Cost Center Report",
      linkTo: "/finance/cost-center-report",
    },
    {
      name: "Interest Calculation Report",
      linkTo: "/finance/interest-calculation-report",
    },
  ]

  return (
    <div className="page-content page-content-index">
      <Container fluid className="">
        <Card className="me-2 px-2 pb-2 mod-landing-panel">
          {/* <Card className="invoice-main-card"> */}
          <FinanceDahboard embedded />
          {/* <Row className="mt-3 mx-1 mb-0">
            {cardData?.length &&
              cardData.map((ele, key) => (
                <Col md={4} xl={3} sm={6} xs={12} key={key}>
                  <Card className="rounded-0 border-0 invoice-card">
                    <CardBody className={`card-body-${key}`}>
                      <Row>
                        <Col lg={"auto"}>
                          <img src={ele?.icon} />
                        </Col>
                        <Col
                          lg={"auto"}
                          className="d-flex justify-content-center flex-column"
                        >
                          <div className="supplier-td-head pb-1">
                            {ele?.name}
                          </div>
                          <div className="dark-text fw-500 text-18">
                            {ele?.amount}
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              ))}
          </Row> */}
          <hr />
          <Row className="mt-4 mx-1 mb-3 finance-shortcuts">
            {/* {menuItem?.submenus?.map(dt => 
            <Col lg={3} sm={4} xs={12}>
              <div className="sub-menu-title mb-3">{dt?.label}</div>
              <Row>
                <Col xs={12}>
                  {dt?.submenus?.map(dt => (
                    <>
                        <Link to={dt?.linkTo}>
                          <div className="mb-1">
                            <span className="list-of-dashmenus">
                              <DotIcon />
                            </span>
                            &nbsp;&nbsp;&nbsp;
                            <label className="sub-menu-link" role="button">
                              {dt?.label}
                            </label>
                            <img src={arrow} alt="" width="7" />
                          </div>
                        </Link>
                    </>
                  ))}
                </Col>
              </Row>
            </Col>
            )} */}

            {menuItem?.submenus?.map((item, index) => (
              <Col lg={3} sm={4} xs={12} key={item?.id || index}>
                <RenderSubmenu item={item} />
              </Col>
            ))}
          </Row>
        </Card>
      </Container>
    </div>
  )
}

export default Finance
